import React from 'react'
import { GoogleMap, useLoadScript } from '@react-google-maps/api';
import { API_KEY_MAP } from 'constants/environment.js'
import { MapDiv } from './style.js'


export default function Map({ children, onMapLoad = () => { }, ...options }) {
    const { loadError, isLoaded } = useLoadScript({
        googleMapsApiKey: API_KEY_MAP
    })
    const [, setMap] = React.useState(null)

    const onLoad = React.useCallback(function callback(map) {
        setMap(map);
        onMapLoad({ map })
        // eslint-disable-next-line
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    return (
        <MapDiv style={{ height: "100%", width: "100%", ...options.divStyle }} >
            {
                isLoaded && !loadError &&
                <GoogleMap
                    mapContainerStyle={{ ...options.mapElementStyle }}
                    onLoad={onLoad}
                    clickableIcons={false}
                    onUnmount={onUnmount}
                    options={{
                        zoomControl: false,
                        streetViewControl: false,
                        fullscreenControl: false,
                        mapTypeControl: false
                    }}
                    {...options}
                >
                    {children}
                </GoogleMap>
            }
        </MapDiv >
    )
}